import styled from 'styled-components';

export const OfferCarouselSection = styled.div`
  padding-top: 16px;
  p {
    font-size: 13px;
    font-weight: 500;
    text-align: left;
    color: rgba(0, 0, 0, 0.4);
  }
`;

export const OffersListHeader = styled.div`
  display: flex;
  align-items: center;
  padding: ${(props) => (props.cart ? '2px 0 8px' : '10px 0 14px')};
  column-gap: 10px;
  font-size: 24px;

  img {
    width: 22px;
    height: 22px;
  }
  @media (min-width: 720px) {
    ${(props) =>
      props.horizontalOnDesktopView &&
      `
            display: flex;
            align-items: center;
            text-align: center;
        `}
  }
`;

export const SeeMore = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0 10px;
  column-gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);

  img {
    width: 16px;
    height: 18px;
    position: relative;
    top: 1px;
  }
  & img {
    width: 13px;
    &.rotate {
      transform: rotate(180deg);
    }
  }
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const HeaderTitle = styled.p`
  font-size: 24px;
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 80%);

  @media (max-width: 720px) {
    font-size: 16px;
  }
`;
export const OfferCardCarousel = styled.div`
  display: flex;
  overflow-x: scroll;
  height: 100px;
  overflow-y: hidden;
  cursor: pointer;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 0px;
    height: 6px;
    cursor: pointer;
    background-color: #f5f5f5;
    transition: height 0.4s ease;
    display: none;

    @media (max-width: 720px) {
      display: none;
    }
  }

  &:hover {
    &::-webkit-scrollbar {
      display: block;

      @media (max-width: 720px) {
        display: none;
      }
    }
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 32%);
    background-color: #c1c1c13b;
  }

  @media (max-width: 720px) {
    height: auto;
  }
`;

export const OfferCard = styled.div`
  align-items: center;
  border: 2px dashed #63b0a8;
  padding: 10px;
  margin: 10px 0;
  flex-shrink: 0;
  display: flex;
  max-width: 80%;
  background: #63b0a90f;
  height: 75px;
  border-radius: 4px;
  cursor: default;
  &:not(:last-child) {
    margin-right: 12px;
  }

  @media (max-width: 720px) {
    height: auto;
  }
`;
export const CouponContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CouponCodeName = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 720px) {
    align-items: flex-start;
  }

  .offerName {
    font-weight: 600;
    margin: 0;
    font-size: 14px;
    padding-bottom: 6px;
    color: rgba(0, 0, 0, 0.8);

    @media (max-width: 720px) {
      margin-left: 0;
    }
  }
  .discountImage {
    margin-right: 8px;
    img {
      width: 22px;
      height: auto;
    }
  }
  p {
    font-size: 12px;
    color: #0000008a;
  }
`;
export const CouponListDiv = styled.div`
  margin: ${(props) => (props.showMargin ? '16px 12px 20px' : '')};
  @media (max-width: 720px) {
    margin: ${(props) => (props.showMargin ? '16px 12px 20px' : '')};
    margin-bottom: ${(props) => (props.removeBottomMargin ? '0px' : '')};
  }

  @media (min-width: 720px) {
    ${(props) =>
      props.horizontalOnDesktopView &&
      `
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            margin: 0 auto;
            overflow-x: auto;
        `}
  }

  .coupon_list_desktop {
    position: relative;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: row;
    width: 90%;
    max-width: 1550px;
    overflow-x: auto;
    justify-content: flex-start;
    background: #fff;
    z-index: 1;
  }
  .coupon_list_desktop .li {
    height: 0;
    width: 400px;
    overflow: hidden;
    padding: 0;
    margin: 0 10px;
    border: none;
    opacity: 0;
    margin-bottom: 8px;

    .valid_till_cart {
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        font-size: 12px;
        font-weight: 500;
        opacity: 0.55;
        padding-right: 12px;
      }
    }
    &.show {
      padding: 6px 0;
      height: 100%;
      border: 1px dashed hsl(0deg 0% 0% / 14%);
      opacity: 1;
      @media (min-width: 720px) {
        &:hover {
          color: hsl(0deg, 0%, 0%, 80%);
          background-color: #f1f1f1;
        }
      }
    }
    &.animate {
      transition:
        all 0.3s ease-in-out 0s,
        height 0s linear 0.05s;
    }
  }
  .coupon_list {
    position: relative;
    width: 100%;
    max-width: 400px;
    padding: 0;
    list-style: none;
    display: block;
    background: #fff;
    z-index: 1;
  }

  .coupon_list .li {
    height: 0;
    overflow: hidden;
    padding: 0;
    border: none;
    opacity: 0;
    margin-bottom: 8px;

    .valid_till_cart {
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        font-size: 12px;
        font-weight: 500;
        opacity: 0.55;
        padding-right: 12px;
      }
    }
    &.show {
      padding: 6px 0;
      height: 100%;
      border: 1px dashed hsl(0deg 0% 0% / 14%);
      opacity: 1;
      @media (min-width: 720px) {
        &:hover {
          color: hsl(0deg, 0%, 0%, 80%);
          background-color: #f1f1f1;
        }
      }
    }
    &.animate {
      transition:
        all 0.3s ease-in-out 0s,
        height 0s linear 0.05s;
    }
  }
  .dropdown_text_only {
    display: flex;
    align-items: center;
  }

  .dropdown_option {
    display: flex;
    flex-direction: column;
    padding: 10px 18px 10px;
    cursor: pointer;

    .dropdown_coupon_name {
      font-size: 13px;
      font-weight: 500;
      opacity: 0.75;

      .coupon_description {
        font-size: 13px;
        font-weight: 500;
        opacity: 0.75;
      }
    }
    .offer_name_heading {
      font-weight: 500;
      padding-bottom: 12px;
      color: hsl(0deg, 0%, 0%, 87%);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .valid_till {
        font-size: 12px;
        font-weight: 500;
        opacity: 0.55;
        white-space: nowrap;
      }
    }
    &:focus {
      color: hsl(0deg, 0%, 0%, 80%);
      background-color: #f1f1f1;
    }
    .heading {
      display: flex;
      align-items: center;
      column-gap: 5px;
      & span {
        color: rgb(0 0 0 / 74%);
        font-weight: bold;
        font-size: 15px;
      }
      & img {
        width: 13px;
        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
    .offers {
      display: flex;
    }
    @media (max-width: 720px) {
      padding: 6px 12px;
      cursor: default;
      .dropdown_coupon_name {
        display: flex;
        flex-direction: column;
        row-gap: 4px;

        .coupon_description {
          margin-left: 0px;
        }
      }
    }
  }
`;

export const OfferCode = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
`;

export const UseCode = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: hsl(0deg, 0%, 0%, 87%);
  column-gap: 6px;
  font-weight: 500;

  strong {
    border-radius: 4px;
    border: dashed 1px #63b0a8;
    background-color: #eefef5;
    padding: 6px;
    font-size: 12px;
  }
`;

export const CopyButton = styled.button`
  font-family: 'Montserrat';
  border: none;
  outline: none;
  background: none;
  color: #ef4e5e;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const CouponListGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 25%;
`;

export const CouponUnorderList = styled.ul`
  margin-left: 14px;
  list-style: disc;

  li {
    padding-bottom: 8px;
  }
`;

export const OfferImage = styled.img`
  width: 100%;
  height: auto;
`;

export const OfferContainerNew = styled.div`
  @media (min-width: 768px) {
    width: 65%;
  }
  .couponSection {
    padding: 16px;
    border: dashed 1px #dadada;
    @media (min-width: 768px) {
      cursor: pointer;
    }
  }
  .offerTitle {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 600;
    color: #000;
  }
  .offerValid {
    font-size: 11px;
    color: #6e6e6e;
    font-weight: normal;
  }
  .lowOpacity {
    opacity: 0.4;
  }
`;

export const OfferDetailsContainer = styled.div`
  display: flex;
  align-items: center;
  .offerDetails {
    padding-top: 10px;
    &:marker {
      opacity: 0.87;
      color: blue;
    }
    flex-basis: 84%;
  }

  .imgContainer {
    padding-top: 33%;
    position: relative;
    flex-basis: 22%;
  }

  .description {
    opacity: 0.87;
    font-size: 12px;
    font-weight: normal;
    margin-bottom: 10px;
    padding-left: 10px;
    position: relative;
    &:before {
      width: 4px;
      content: '';
      height: 4px;
      border-radius: 50%;
      background-color: #6e6e6e;
      margin-right: 6px;
      display: block;
      position: absolute;
      left: 1px;
      top: 7px;
    }
  }
`;

export const CouponAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 768px) {
    cursor: pointer;
  }
  margin-top: 10px;
  .couponCode {
    background: url('https://images.myloapp.in/NestJsUploads/1691478335517-Subtraction-2@3x.webp')
      center center no-repeat;
    background-size: contain;
    padding: 10px 16px;
    display: block;
    font-size: 12px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
  }

  .copyButton {
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 600;
    color: #ef4e5e;
    background: #fff;
    padding: 10px 4px;
    text-transform: uppercase;
    border: none;
    @media (min-width: 768px) {
      cursor: pointer;
    }
  }
`;
